export const siteConfig = {
  name: "Arlet Engineering",
  legalName: "ARLET engineering s.r.o.",
  claim: "Projekční a technická kancelář",
  description:
    "Projekční a technická kancelář se zaměřením na projektování potrubí, pevnostní a hydraulické výpočty potrubních systémů pro papírenský, chemický a energetický průmysl.",
  url: "https://arlet.cz",
  locale: "cs_CZ",
  founded: 2006,
  since: 1988,
  contact: {
    phone: "+420 721 367 270",
    phoneHref: "tel:+420721367270",
    email: "info@arlet.cz",
    emailHref: "mailto:info@arlet.cz",
    street: "Zahradní 762",
    city: "739 21 Paskov",
    country: "Česká republika",
    mapUrl: "https://goo.gl/maps/CHTwFrVE91o",
  },
  languages: ["Čeština", "Angličtina", "Němčina"],
} as const;

export type SiteConfig = typeof siteConfig;
